export default __webpack_public_path__ + "static/media/Exceptional Elixir of Resurgence.a157fa48.jpg";